<div class="bubble-container">
  @if (['failed', 'undelivered'].includes(messageStatus()!)) {
    <mat-icon class="error-icon">error</mat-icon>
  }
  <div
    class="message"
    [class.bubble]="!noBubble()"
    [ngClass]="itemContent() === 'message' ? 'content-message' : 'content-attachment'"
  >
    @if (!isTyping()) {
      <div #bubbleElement [class.message-is-markdown]="messageIsMarkdown()"></div>
      <ng-content />
    } @else {
      <div class="dot"></div>
      <div class="dot"></div>
      <div class="dot"></div>
    }
  </div>
</div>

<div class="metadata" [class.show]="isMetadataPresented()">
  <ng-content select="glxy-additional-metadata" />
  <span class="message-status-time">
    @if (messageStatusText()) {
      <span class="message-status">{{ messageStatusText() | translate }}</span>
    }
    @if (messageTime()) {
      <span class="message-time">{{ messageTime() }}</span>
    }
  </span>
</div>
